import React from "react"

import { Form, Formik } from "formik"

import classNames from "src/classNames"

import { gql, useMutation } from "hooks/urql"

import { handleFailure } from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody, { Footer } from "components/ModalWithProvidedBody"

type RemoveAcrClassProps = {
  id: string
  buttonClassSize?: "sm" | "md"
}

const RemoveAcrClass: React.FC<RemoveAcrClassProps> = ({
  id,
  buttonClassSize = "md",
}) => {
  const [, removeAcrClass]: any[] = useMutation(deleteAcrClassMutation)

  const handleSubmit = (_values: Record<string, never>, actions: any) => {
    removeAcrClass({ id })
      .then((response: any) => {
        const { failures, redirectTo } = response.data.deleteAcrClass
        if (redirectTo) {
          window.location.href = redirectTo
        } else {
          handleFailure(actions, failures)
        }
      })
      .catch(() => handleFailure(actions))
  }

  const buttonClassName = classNames(
    "btn btn-danger",
    buttonClassSize === "sm" ? "btn-sm" : "btn-md"
  )

  return (
    <ModalWithProvidedBody
      modalTitle="Remove Air Classroom Class"
      buttonText="Remove"
      buttonClassName={buttonClassName}
    >
      {({ closeModal }) => (
        <Formik initialValues={{}} onSubmit={handleSubmit}>
          <Form>
            <div className="modal-body">
              <p className="alert alert-danger">
                Are you sure? This will permanently remove this Air Classroom
                Class!
              </p>
            </div>
            <Footer
              cancelAction={closeModal}
              cancelText="No, keep it!"
              submitText="Yes, remove this class"
              isDangerous
            />
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const deleteAcrClassMutation = gql`
  mutation ($id: ID!) {
    deleteAcrClass(id: $id) {
      redirectTo
      failures {
        message
      }
    }
  }
`

export default RemoveAcrClass
